import React, { useState, useEffect } from "react";
import { v4 as uuid } from "uuid";

import PrimaryTabs from "../../components/PrimaryTabs";
import ProductGallery from "./ProductGallery";
import ProductMainDetails from "./ProductMainDetails";
import Description from "./DescriptionTab";
import DeliveryTab from "./DeliveryTab";
import NutritionFactsTab from "./NutritionFactsTab";
import CustomerReviews from "../../components/CustomerReviews";
import Snacks from "../../components/Snacks";
import Container from "../../components/Container";

const tabs = [
  {
    tabId: uuid().slice(0, 8),
    value: "description",
    text: "Description",
    TapPanelContent: Description,
  },
  {
    tabId: uuid().slice(0, 8),
    value: "delivery",
    text: "Delivery",
    TapPanelContent: DeliveryTab,
  },
  {
    tabId: uuid().slice(0, 8),
    value: "nutrition-facts",
    text: "Nutrition Facts",
    TapPanelContent: NutritionFactsTab,
  },
];

const Product = () => {
  const [tabsInfo, setTabsInfo] = useState(tabs);
  const [snacks, setSnacks] = useState({});
  useEffect(() => {
    import("./snacks.json").then((data) => setSnacks(data));
  }, []);

  return (
    <div className="bg-white">
      <section>
        <Container display={"flex xs:flex-col md:flex-row"}>
          <div className="product-images xs:w-full md:w-7/12 mb-4 px-4">
            <ProductGallery />
          </div>
          <div className="product-info flex-auto px-4">
            <ProductMainDetails />
          </div>
        </Container>
      </section>
      <section>
        <Container>
          <PrimaryTabs tabsInfo={tabsInfo} />
        </Container>
      </section>
      <section>
        <Container>
          <CustomerReviews />
        </Container>
      </section>
      <section>
        <Container
          maxWidth={
            "xs:max-w-full md:max-w-[720px] lg:max-w-[960px] xl:max-w-[1140px]"
          }
          width={"w-full"}
        >
          <Snacks data={snacks}>
            <div className="text-center">
              Check out{" "}
              <strong className="text-[#5f5f5f] font-semibold">
                {snacks && snacks.influencer}
              </strong>
              , hard to find healthy snacks
            </div>
          </Snacks>
        </Container>
      </section>
    </div>
  );
};

export default Product;
